
import base from "@packages/api/core/baseCore";
import Vue from "vue";

export default Object.assign(
    {
        apiUrl: "/voucher/segment",

        async list() {
            const url = this.url("/list");

            return Vue.http.get(url);
        },

        async create({ name, onceTimePerDay, type }) {
            const url = this.url("/");

            return Vue.http.post(url, {
                name,
                onceTimePerDay,
                type,
            });
        },

        async update({ name, onceTimePerDay, segmentId }) {
            const url = this.url(`/${segmentId}`);

            return Vue.http.put(url, {
                name,
                onceTimePerDay,
            });
        },

        async delete({ segmentId }) {
            const url = this.url(`/${segmentId}`);

            return Vue.http.delete(url);
        },
    },
    base
);
